import React from 'react';

const ProblemSection = ({ problems }) => {
  return (
    <section style={{ background: 'var(--bg-page)', padding: '120px 0' }}>
      <div className="container">
        <div style={{ marginBottom: '80px', textAlign: 'center' }}>
          <h2 className="heading-2" style={{ color: 'var(--text-primary)', marginBottom: '24px' }}>
            THE QUESTIONS KEEPING PARENTS AWAKE
          </h2>
          <p className="body-medium" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            You're not alone. Every parent faces these anxieties when choosing or evaluating their child's school.
          </p>
        </div>

        <div className="pixel-pushers-grid">
          {problems.map((problem, index) => (
            <div
              key={problem.id}
              style={{
                background: 'var(--bg-card)',
                padding: '48px 40px',
                width: 'calc(33.333% - 14px)',
                minWidth: '300px',
                border: '2px solid var(--border-medium)',
                borderRadius: '8px',
                transition: 'all 0.3s ease',
              }}
              className="problem-card"
            >
              <div
                style={{
                  color: 'var(--brand-primary)',
                  fontSize: '3rem',
                  fontWeight: '900',
                  marginBottom: '24px',
                  fontFamily: "'PP Right Grotesk', Arial, sans-serif",
                  lineHeight: '1',
                }}
              >
                0{index + 1}
              </div>
              <h3
                className="heading-4"
                style={{
                  color: 'var(--text-primary)',
                  marginBottom: '16px',
                  textTransform: 'uppercase',
                }}
              >
                {problem.question}
              </h3>
              <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '20px' }}>
                {problem.description}
              </p>
              <p className="caption" style={{ color: 'var(--brand-primary)' }}>
                {problem.impact}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
